import React from 'react'

const PortfolioCTA = () => {
  return (
    <section id='PortfolioCTA'>
        <div className="portfoliocta-wrapper">
            <div className="pcta-content">
                <h2 className='pcta-heading'>Curious what I've been building?</h2>
                <p>Here are some of my favorite works.</p>
            </div>
            <a href="/portfolio" className='portfolio-CTA'>
                <p>View My Work</p>
            </a>
        </div>
    </section>
  )
}

export default PortfolioCTA